import useScrollAnimation from "@/hooks/useScrollAnimation";
import { trustBarData } from "@/mocks/homeData";

export default function TrustBar() {
  const { ref, isVisible } = useScrollAnimation(0.3);

  return (
    <section className="w-full py-8 md:py-10 bg-background-100 border-y border-background-200/70">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <p className="text-center text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-wider mb-5 md:mb-6">
          {trustBarData.label}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 md:gap-x-12 lg:gap-x-16">
          {trustBarData.clients.map((client) => (
            <div
              key={client.name}
              className="flex items-center gap-2.5 text-foreground-400 hover:text-foreground-600 transition-colors"
            >
              <i className={`${client.logo} text-lg md:text-xl`} />
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">
                {client.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}